import React from 'react';
import { Modal } from 'rsuite';
import PricingMarginsEdit from './Edit/PricingMarginsEdit';

interface Props {
  isOpen: boolean;
  marketplaceCode: string;
  partnerProductCode: string;
  onClose: () => void;
  onSaved: () => void;
}

export default function PricingMarginsEditModal({
  isOpen,
  marketplaceCode,
  partnerProductCode,
  onClose,
  onSaved,
}: Props): JSX.Element {
  return (
    <Modal
      open={isOpen}
      onClose={() => onClose()}
      backdrop="static"
      overflow
    >
      <Modal.Header>
        <Modal.Title>
          {`Edit margins - ${partnerProductCode} (${marketplaceCode})`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PricingMarginsEdit
          marketplaceCode={marketplaceCode}
          partnerProductCode={partnerProductCode}
          onCancel={() => onClose()}
          onSaved={() => onSaved()}
        />
      </Modal.Body>
    </Modal>
  );
}
